import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconText = (props) => (
  <Box component="span" sx={{ marginLeft: '4px', marginRight: '4px' }}>
    {props.children}
  </Box>
);

IconText.propTypes = {
  children: PropTypes.string.isRequired,
};

export default IconText;
